import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'
import store from '../store/index'

export function _getAll(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/approves`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _approve(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/approves/approve`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
} 
export function _getMyApproveIfExist(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/approves/getMyApproveIfExist`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
} 
export function _reject(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/approves/reject`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
} 